import React from 'react';
import i18next from 'i18next';
import ReactTooltip from 'react-tooltip';

import energyIcon from '~assets/ic_general_energy_gray.svg';
import transportIcon from '~assets/ic_general_truck_gray.svg';
import boundaryIcon from '~assets/ic_general_borders_gray.svg';
import telecommunicationsIcon from '~assets/ic_general_communications.svg';
import energyIconDark from '~assets/ic_general_energy_black.svg';
import transportIconDark from '~assets/ic_general_truck_black.svg';
import boundaryIconDark from '~assets/ic_general_borders_black.svg';
import multimodalIconDark from '~assets/ic_general_multimodal_dark.svg';
import roadIconDark from '~assets/ic_general_road_dark.svg';
import telecommunicationsIconDark from '~assets/ic_general_communications_black.svg';
import seaIconDark from '~assets/ic_general_sea_black.svg';
import shipIconDark from '~assets/ic_general_ship_black.svg';
import trainIconDark from '~assets/ic_general_train_black.svg';
import airplaneIconDark from '~assets/ic_general_airplane_black.svg';

import { TOPICS } from '~constants/content';

import styles from './styles.module.scss';
import Share from "~components/Share";
import transportImage
  from "~screens/Dashboard/screens/Projects/components/ProjectMarker/assets/ic_proyectos_truck_pin.svg";
import carreteroImage
  from "~screens/Dashboard/screens/Projects/components/ProjectMarker/assets/ic_proyectos_carretero_pin.svg";
import multimodalImage
  from "~screens/Dashboard/screens/Projects/components/ProjectMarker/assets/ic_proyectos_multimodal_pin.svg";

interface Props {
  className?: string;
  type?: string;
  infrastructure: {
    id: number;
    name: string;
  };
  subsector?: {
    id: number;
    name: string;
  };
  imgClass?: string;
  textClass?: string;
  dark?: boolean;
  compact?: boolean;
  shareUrl?: string;
  shareVerticalPosition?: boolean;
  isCard?: boolean;
}

interface IconMap {
  [key: string]: any;
}

const ICON: IconMap = {
  'energía': energyIcon,
  'transporte': transportIcon,
  '': boundaryIcon,
  'telecomunicaciones': telecommunicationsIcon
};

const DARK_ICON: IconMap = {
  'energía': energyIconDark,
  'energia': energyIconDark,
  'transporte': transportIconDark,
  '': boundaryIconDark,
  'telecomunicaciones': telecommunicationsIconDark,
  'comunicaciones': telecommunicationsIconDark,
  'comercio': transportIconDark,
  'producción': transportIconDark,
  'produccion': transportIconDark,
  'infraestructura': roadIconDark,
  'medio ambiente': multimodalIconDark,
  'social': multimodalIconDark,
  'transporte aéreo': airplaneIconDark,
  'transporte aereo': airplaneIconDark,
  'transporte marítimo': seaIconDark,
  'transporte maritimo': seaIconDark,
  'transporte fluvial': shipIconDark,
  'transporte ferroviario': trainIconDark,
  'pasos de frontera': boundaryIconDark,
  'transporte carretero': roadIconDark,
  'logística': transportIconDark,
  'logistica': transportIconDark,
};

function getInfCode(infrastructure, subsector?: { id: number; name: string; nameEs?: string }) {
  let infCode;
  if(Array.isArray(infrastructure)) {
    infCode = infrastructure[0].toLowerCase();
  } else if(infrastructure) {
    // Icon map keys are Spanish, so always resolve from the canonical
    // Spanish name (`nameEs`, exposed by every parametric serializer)
    // rather than the language-dependent `name`.
    const sectorName = infrastructure.nameEs || infrastructure.name;
    infCode = sectorName.toLowerCase();
    if (infCode === 'transporte' && subsector) {
      const subsectorName = subsector.nameEs || subsector.name;
      if (subsectorName) {
        infCode = subsectorName.toLowerCase();
      }
    }
  }
  return infCode;
}

function ContentType({ className, type, infrastructure, subsector, dark, compact, imgClass, textClass, shareUrl, shareVerticalPosition, isCard }: Props) {
  const icons = DARK_ICON;
  const descriptionClassName =  dark ? styles.descriptionDark : styles.descriptionWhite;

  const infArray = Array.isArray(infrastructure);
  const singleInf = !infArray || infrastructure.length == 1;

  const showText = singleInf || !isCard;

  function renderInfrastructure(inf) {
    return (
      <>
        { !showText && (
          <img alt="" src={icons[getInfCode(inf, subsector)]} data-tip={inf.name} className={`m-right-1 ${imgClass}`} />
        )}

        { showText && (
          <img alt="" src={icons[getInfCode(inf, subsector)]} className={`m-right-1 ${imgClass}`} />
        )}
        
        { showText && (
          <span className={`${textClass}`}>
            {inf.name}
          </span>
        )}
  
        {/*{ showText && !isCard && !singleInf && (infrastructure.indexOf(inf) != infrastructure.length-1) && (*/}
        {/*  " - "*/}
        {/*)}*/}
  
      </>
    );
  }

  return (
    <div className={`middle ${styles.description} ${descriptionClassName} ${compact ? styles.compact : ''} ${className}`}>
      
      {infrastructure && !infArray && (
        renderInfrastructure(infrastructure)
      )}

      {/*{infrastructure && infArray && infrastructure.map(inf => */}
      {/*  renderInfrastructure(inf)*/}
      {/*)}*/}

      {/*{type && (*/}
      {/*    <span className={`line-separator-b ${textClassName} ${textClass}`}>*/}
      {/*    {i18next.t(`contentType:${type.toLowerCase()}`)}*/}
      {/*  </span>*/}
      {/*)}*/}
      {/*{shareUrl &&*/}
      {/*<Share*/}
      {/*    className={`${styles.share}`}*/}
      {/*    url={shareUrl}*/}
      {/*    position="right"*/}
      {/*    verticalPosition={shareVerticalPosition}*/}
      {/*/>*/}
      {/*}*/}
      <ReactTooltip />
    </div>
  );
}

export default ContentType;
